import { render } from "./SkyButtonConfirm.vue?vue&type=template&id=2b744ba6&scoped=true"
import script from "./SkyButtonConfirm.vue?vue&type=script&lang=js"
export * from "./SkyButtonConfirm.vue?vue&type=script&lang=js"

import "./SkyButtonConfirm.vue?vue&type=style&index=0&id=2b744ba6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b744ba6"]])

export default __exports__